var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { AbstractButton } from './abstract-button';
import React from 'react';
import { IconArrowForward } from '@axafr-btc-ds/icons';
import { ColorSemanticHex } from '@axafr-btc-ds/colors';
import { buttonTheme } from './css/css';
var businessBtnProps = {
    bgColor: ColorSemanticHex.businessDefault,
    borderColor: ColorSemanticHex.businessDefault,
    fontColor: ColorSemanticHex.neutral10,
    hoverBgColor: ColorSemanticHex.businessHover,
    hoverBorderColor: ColorSemanticHex.businessHover,
    hoverFontColor: ColorSemanticHex.neutral10,
    activeBgColor: ColorSemanticHex.businessActive,
    activeBorderColor: ColorSemanticHex.businessActive,
    activeFontColor: ColorSemanticHex.neutral10
};
export var BusinessButton = React.forwardRef(function (props, ref) { return (React.createElement(AbstractButton, __assign({}, props, { ref: ref, cssTheme: buttonTheme(businessBtnProps), icon: IconArrowForward }))); });
